import { useContext, useEffect, useState } from 'react';
import { FilterContext } from '../../../filterTools';
import { LivingSpaceRangeSlider } from './LivingSpaceRangeSliderComponent';
import { PriceRangeSlider } from './PriceRangeSliderComponent';
import { RoomRangeSlider } from './RoomRangeSliderComponent';
import { EstateType } from '../../../Enums';

const RangeSliders = ({ tabIndex }: { tabIndex?: number }): JSX.Element => {
  const filterContext = useContext(FilterContext);
  const [filteredEstateTypes, setFilteredEstateTypes] = useState<EstateType[]>(
    []
  );

  function updateRangeTags(name: string, minVal: number, maxVal: number) {
    const existingTag = filterContext.tags.some(
      (x) => x.name === name && x.type === 'rangeTag'
    );

    if (existingTag) {
      filterContext.setTags(
        filterContext.tags.filter((x) => {
          if (x.name === name && x.type === 'rangeTag') {
            x.minVal = minVal;
            x.maxVal = maxVal;
          }
          return x;
        })
      );
    } else {
      filterContext.setTags([
        ...filterContext.tags,
        { name, minVal, maxVal, type: 'rangeTag' },
      ]);
    }
  }

  useEffect(() => {
    const filteredEstateTypes = filterContext.tags
      .filter((tag) => tag.type === 'estateType')
      .map((tag) => tag.estateType);

    setFilteredEstateTypes(filteredEstateTypes as EstateType[]);
  }, [filterContext.tags]);

  return (
    <>
      <PriceRangeSlider updateRangeTags={updateRangeTags} tabIndex={tabIndex} />
      {(filteredEstateTypes.length === 0 ||
        filteredEstateTypes.includes(EstateType.House) ||
        filteredEstateTypes.includes(EstateType.Cottage) ||
        filteredEstateTypes.includes(EstateType.Cooperative) ||
        filteredEstateTypes.includes(EstateType.Project) ||
        filteredEstateTypes.includes(EstateType.Agriculture) ||
        filteredEstateTypes.includes(EstateType.RowHouse) ||
        filteredEstateTypes.includes(EstateType.OwnedApartment)) && (
        <RoomRangeSlider
          updateRangeTags={updateRangeTags}
          tabIndex={tabIndex}
        />
      )}
      {(filteredEstateTypes.length === 0 ||
        filteredEstateTypes.includes(EstateType.House) ||
        filteredEstateTypes.includes(EstateType.Cottage) ||
        filteredEstateTypes.includes(EstateType.Cooperative) ||
        filteredEstateTypes.includes(EstateType.RowHouse) ||
        filteredEstateTypes.includes(EstateType.OwnedApartment)) && (
        <LivingSpaceRangeSlider
          updateRangeTags={updateRangeTags}
          tabIndex={tabIndex}
        />
      )}
    </>
  );
};
export default RangeSliders;
